import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M8 3H5a2 2 0 0 0-2 2v3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 8V5a2 2 0 0 0-2-2h-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 16v3a2 2 0 0 0 2 2h3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 21h3a2 2 0 0 0 2-2v-3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Maximize";
const Maximize = memo(themed(Icon));
export {
  Maximize
};
//# sourceMappingURL=maximize.js.map
